import { useEffect, useRef, useState } from 'react';

export const useInterval = (intervalMs: number, callback?: (num: number) => void) => {
  const [count, setCount] = useState(0);

  function stateCallback() {
    if (callback != null) {
      callback(count);
    } else {
      setCount(count + 1);
    }
  }

  const savedCallback = useRef(stateCallback);
  useEffect(() => {
    savedCallback.current = stateCallback;
  });

  useEffect(() => {
    function tick() {
      savedCallback.current();
    }

    const id = setInterval(tick, intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return count;
};
